import { SelectionTargetRefusal } from '../../../lib/types/selection-target.types';
import { IIntlMessage } from '../IntlMsg/intl-msg.types';
import { messages } from './selection-target-gate.messages';

// How long a link may hold the page before it opens on the current selection while the switch finishes.
export const SELECTION_TARGET_HOLD_MS = 2000;

export const REFUSAL_MESSAGES: Record<SelectionTargetRefusal, IIntlMessage> = {
  [SelectionTargetRefusal.NOT_FOUND]: messages.notFound,
  [SelectionTargetRefusal.CONFLICT]: messages.conflict,
  [SelectionTargetRefusal.MISSING_PERMISSION]: messages.missingPermission,
};
